<ion-app>
  <ion-router-outlet></ion-router-outlet>

  <!-- Global Language Switcher - Fixed Right Center Position -->
  <app-global-language-switcher></app-global-language-switcher>
</ion-app>